/* eslint-disable import/prefer-default-export */

export const navigationGuard = (to, from, next) => {
  if (JSON.parse(localStorage.getItem('USERDATA')).type === 'U') {
    next('panel/vouchers');
  } else {
    next();
  }
};
